export default {
  DASHBOARD: {
    TITLE: 'Dashboard',
    FILTERS: {
      DATE: {
        PLACEHOLDER: 'Date range',
        MONTH: 'Last 30 days',
        SEMESTER: 'Last 6 months',
        YEAR: 'Last 12 months',
        ALL: 'All time',
      },
      SECTOR: {
        PLACEHOLDER: 'Industry*',
        HELP: '*The industry filter only applies to company KPIs, not users.',
      },
      COUNTRY: { PLACEHOLDER: 'Country' },
      STATE: { PLACEHOLDER: 'State / Province' },
    },
    KPI: {
      AVG: '% of wokap total',
      ENTITY: {
        TITLE: 'Companies',
        TOTAL_ENTITIES: {
          TEXT: 'Total companies',
          TOOLTIP: 'Total number of companies registered on wokap',
        },
        ACTIVE_ENTITIES: {
          TEXT: 'Active',
          TOOLTIP: 'Companies that logged in or performed an action in the last month',
        },
        OFFERS_PUBLISHED: {
          TEXT: 'Jobs posted',
          TOOLTIP: 'Total number of jobs posted by companies',
        },
        AVERAGE_OFFERS_PER_ENTITY: {
          TEXT: 'Avg. jobs / company',
          TOOLTIP: 'Total jobs divided by total companies',
        },
        USERS_SUBSCRIBED_TO_OFFERS: {
          TEXT: 'Applicants',
          TOOLTIP: 'Total number of users who applied to jobs',
        },
        AVERAGE_USERS_SUBSCRIBED_TO_OFFERS: {
          TEXT: 'Avg. applicants / job',
          TOOLTIP: 'Total applicants divided by the number of jobs posted',
        },
        RETENTION_RATE: {
          TEXT: 'Retention rate',
          TOOLTIP: '% of companies active in the last month vs. total companies',
        },
        SECTOR_MOST_COMMON: {
          TEXT: 'Top industries',
          TOOLTIP: 'Industries with the highest presence',
          XAXIS_TITLE: 'Industries',
        },
      },
      USER: {
        TITLE: 'Users',
        TOTAL_USERS: {
          TEXT: 'Registered users',
          TOOLTIP: 'Users who created an account. Note: not all are active job seekers',
        },
        ACTIVE_USERS: {
          TEXT: 'Active',
          TOOLTIP: 'Users who logged in or performed an action in the last 30 days',
        },
        USERS_APPLIED: {
          TEXT: 'Active applicants',
          TOOLTIP: 'Users who applied to at least one job, showing active job-seeking intent',
        },
        TOTAL_APPLICATIONS: {
          TEXT: 'Total applications',
          TOOLTIP: 'Total number of applications submitted (users can apply multiple times)',
        },
        AVERAGE_APPLICATIONS_PER_USER: {
          TEXT: 'Avg. applications / user',
          TOOLTIP: 'Total applications divided by active applicants',
        },
        PERCENTAGE_USERS_APPLIED: {
          TEXT: 'Application rate',
          TOOLTIP: '% of registered users actively applying for jobs',
        },
        FINALIST_APPLICATIONS: {
          TEXT: 'Finalist rate',
          TOOLTIP: '% of applications that reached the finalist stage',
        },
        AGE_AVERAGE: {
          TEXT: 'Avg. age',
          TOOLTIP: 'Average age of registered users',
        },
        OCCUPATION_MOST_COMMON: {
          TEXT: 'Top job roles',
          TOOLTIP: 'Most common job roles among registered users',
          XAXIS_TITLE: 'Job roles',
        },
      },
    },
  },
} as const;
